import { useContext, useCallback, memo } from 'react';
import { BigJunctureSubStationWrapper } from './BigJunctureSubStation.styled';
import StationIcon from 'components/common/StationIcon';
import { IconWrapper } from '../../../Station.styled';
import { ZoneContext } from 'context/ZoneContext';
import { Description } from '../../Description';
import { Station } from 'pages/Map/types';
import { MapTourContext } from 'context/MapTourContext';
import { TourType } from 'pages/Map/components/MapTour';
import useMapSearch from 'hooks/search/useMapSearch';

type BigJunctureSubStation = {
    station: Station;
    isBigJunctureExpanded: boolean;
};
export const BigJunctureSubStation = memo(({ station, isBigJunctureExpanded }: BigJunctureSubStation) => {
    const { setSelectedStation, activeStation, expandedDescriptionStation, setExpandedDescriptionStation, paths, selectedStation } =
        useContext(ZoneContext);
    const isDescriptionExpanded = expandedDescriptionStation && expandedDescriptionStation.id === station.id;
    const defaultZIndex = station.getDefaultZIndex(activeStation);
    const stationZIndex = isDescriptionExpanded ? station.getHoveredZIndex(defaultZIndex) : defaultZIndex;
    const { isCurrentTourItem } = useContext(MapTourContext);
    const { getSearchStatus, getSearchColor } = useMapSearch();
    const stationStatus = station.getStationStatus(activeStation, paths, selectedStation);
    const backgroundColor = getSearchColor(station.id) || station.getStationColor(stationStatus);

    const onDescriptionExpand = useCallback(() => {
        setExpandedDescriptionStation(station);
    }, []);

    const onDescriptionCollapse = useCallback(() => {
        setExpandedDescriptionStation(undefined);
    }, []);

    const onStationClick = useCallback(() => {
        setSelectedStation(station);
    }, [station, setSelectedStation]);

    const style = {
        zIndex: stationZIndex
    };

    return (
        <BigJunctureSubStationWrapper
            style={style}
            isMapTourActiveElement={isCurrentTourItem(TourType.INFO_ABOUT_STATIONS)}
            id={station.id}
            isDescriptionExpanded={!!isDescriptionExpanded}
            isSearchStation={!!getSearchStatus(station.id)}
        >
            <IconWrapper
                isPathSelectedInTour={false}
                onClick={onStationClick}
                onMouseEnter={onDescriptionExpand}
                onMouseLeave={onDescriptionCollapse}
                style={{ backgroundColor }}
            >
                <StationIcon type={station.getType()} isHighlight={isDescriptionExpanded || station.isSelectedStation(selectedStation)} />
            </IconWrapper>
            {isBigJunctureExpanded ? (
                <Description
                    onDescriptionExpand={onDescriptionExpand}
                    onDescriptionCollapse={onDescriptionCollapse}
                    station={station}
                    isActiveStation={false}
                    onClick={onStationClick}
                />
            ) : null}
        </BigJunctureSubStationWrapper>
    );
});
